import * as React from 'react';
import { ReactNode } from 'react';
import Grid from '@mui/material/Grid2';

export interface AboutToolWrapperProps {
  pageHeader: ReactNode;
  leftChild: JSX.Element;
  rightChild: JSX.Element;
  dataTestId: string;
}

export default function AboutToolWrapper(props: AboutToolWrapperProps) {
  const { pageHeader, leftChild, rightChild, dataTestId } = props;

  return (
    <>
      {pageHeader}
      <Grid
        container
        data-testid={dataTestId}
        id="about-tool-wrapper"
        m={2}
        spacing={2}
      >
        <Grid size={{ sm: 12, md: 6 }}>{leftChild}</Grid>
        <Grid size={{ sm: 12, md: 6 }} mb={3}>
          {rightChild}
        </Grid>
      </Grid>
    </>
  );
}
